// Components
import MenuCategoryCard from "../../card/variants/menu-category-card/MenuCategoryCard";
// Types and Interfaces
import MenuCategory from "../../../constants/interfaces/MenuCategory";
// Functions, Helpers, and Utils
import { Locale, getLocalization } from "../../../helpers/localization";
// Constants
import menuDataEN from "../../../constants/locales/en-US/menu";
import menuDataES from "../../../constants/locales/es-US/menu";

const CategoryShowcase: React.FC<{ deviceLanguage: Locale }> = ({
  deviceLanguage,
}) => {
  // Select the right menu data based on device language
  const menuStrings: MenuCategory[] =
    deviceLanguage === "en-US" ? menuDataEN : menuDataES;

  return (
    <section className="category-showcase padding-left-and-right padding-top-80">
      <div className="section-header display-grid">
        <div>
          <h1 className="section-title padding-bottom-10">
            <span className="neutral-accent-text">
              {getLocalization(
                "home",
                "categoryShowcaseHighlight",
                deviceLanguage
              )}
            </span>{" "}
            {getLocalization("home", "categoryShowcase", deviceLanguage)}
          </h1>
          <p className="section-description padding-top-20 padding-bottom-40">
            {getLocalization(
              "home",
              "categoryShowcaseDescription",
              deviceLanguage
            )}
          </p>
        </div>
      </div>

      <div className="menu-category-card-wrapper display-grid">
        {menuStrings.map((item: MenuCategory) => (
          <MenuCategoryCard
            key={item.name}
            title={getLocalization("menu", item.name, deviceLanguage)}
            description={getLocalization(
              "menu",
              item.description,
              deviceLanguage
            )}
            image={item.image}
            deviceLanguage={deviceLanguage}
          />
        ))}
      </div>
    </section>
  );
};

export default CategoryShowcase;
